module.exports = __webpack_public_path__ + "static/GetTickets-1592fddd0fb1fe0f6dcd316c4c3cb879.svg";